module.exports = __webpack_public_path__ + "img/advantageIcons.d6e12957.png";